module.exports = __webpack_public_path__ + "img/android_download_guide.7542da14.png";